const fontSizes = {
  xxs: '12px',
  xs: '13px',
  sm: '14px',
  m: '15px',
  md: '16px',
  lg: '18px',
  xl: '24px',
  xxl: '32px',
};

export const commonThemeStyles = {
  fontSizes,
};
